import React, { Component } from 'react'
import { Crementer } from '../shared/NumberCrementer'
import { selectors as inventorySelectors } from '../sagas/inventory'
import { actions } from '../sagas/inventory/new'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import _ from 'lodash'

class KegSize extends Component {
  constructor(props) {
    super(props)
    this.create = this.props.actions.inventoryActions.createInventory.bind(this)
    this.destroy = this.props.actions.inventoryActions.destroyInventory.bind(this)
  }

  getCheckedinCount = () => {
    return this.props.product
      && this.props.product['attributes']
      && this.props.product['attributes']['availableInventoryCount']
  }

  getInventoryCount = () => {
    return this.props.product
      && this.props.product['attributes']
      && this.props.product['attributes']['futureInventoryCount']
  }

  render() {
    let checkedinCount = this.getCheckedinCount()
    let inventoryCount = this.getInventoryCount()

    let count = this.props.stocked ? inventoryCount : checkedinCount

    return(
      <div style={ this.props.style } key={this.props.size['id']} className='inventory-col half'>
        <div>
          { !this.props.stocked && count &&
              <Crementer
                wrapperClass='inventory-crement-wrapper'
                value={ count[_.camelCase(this.props.size['size'])] }
                increment={() => this.create(this.props.product['id'], this.props.size['id'], { inventory_type: 'available' })}
                decrement={() => this.destroy(this.props.product['id'], this.props.size['id'], { inventory_type: 'available' })}
                incrementClass={'add-inventory'}
                decrementClass={'remove-inventory'}
              />
          }
          { this.props.stocked && count &&
              <Crementer
                wrapperClass='inventory-crement-wrapper'
                value={ count[_.camelCase(this.props.size['size'])] }
                increment={() => this.create(this.props.product['id'], this.props.size['id'], { inventory_type: 'future' })}
                decrement={() => this.destroy(this.props.product['id'], this.props.size['id'], { inventory_type: 'future' })}
                incrementClass={'add-inventory'}
                decrementClass={'remove-inventory'}
              />
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = (store) => ({
  kegs: inventorySelectors.kegs,
  stocked: inventorySelectors.stocked(store)

})

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      inventoryActions: bindActionCreators(actions, dispatch),
    }
  }
}
export default (connect(mapStateToProps, mapDispatchToProps)(KegSize))



// WEBPACK FOOTER //
// ./src/Inventory/KegSize.js